import React from 'react';

interface CreatorProfileProps {
  name: string;
  imageUrl?: string;
  size?: 'xs' | 'sm' | 'md' | 'lg';
  showName?: boolean;
  year?: string;
}

const CreatorProfile: React.FC<CreatorProfileProps> = ({
  name,
  imageUrl,
  size = 'md',
  showName = true,
  year
}) => {
  const sizeClasses = {
    xs: 'w-8 h-8 text-base',
    sm: 'w-10 h-10 text-lg',
    md: 'w-12 h-12 text-xl',
    lg: 'w-14 h-14 text-2xl'
  };

  return (
    <div className="flex items-center gap-4 group cursor-pointer">
      {imageUrl ? (
        <div className={`${sizeClasses[size]} rounded-full overflow-hidden bg-gray-100 ring-2 ring-offset-2 ring-black/5`}>
          <img 
            src={imageUrl} 
            alt={name}
            className="w-full h-full object-cover transition-transform group-hover:scale-110"
          />
        </div>
      ) : (
        <div className={`${sizeClasses[size]} rounded-full bg-gray-100 flex items-center justify-center ring-2 ring-offset-2 ring-black/5`}>
          <span className="text-gray-500 font-light">
            {name.charAt(0)}
          </span>
        </div>
      )}
      {showName && (
        <div>
          <p className="text-lg font-medium group-hover:text-gray-600 transition-colors">{name}</p>
          {year && <p className="text-gray-500">{year}</p>}
        </div>
      )}
    </div>
  );
};

export default CreatorProfile;
